// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PlanStore, for use in the registry */ export const PlanStoreActionTypes = [
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.FetchAllPlansForContainerTypeAction,
    ActionType.FetchAllPlansForContainerTypeFailedAction,
    ActionType.FetchAllPlansForContainerTypeSucceededAction,
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.DeltaSyncFailedAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.UndoRedoUpdateEntitySucceededAction,
    ActionType.SetDefaultPlanAction,
    ActionType.ClearDefaultPlanAction,
    ActionType.FetchDefaultPlanAction,
    ActionType.FetchDefaultPlanFailedAction,
    ActionType.SetFlaggedEmailPlanAction,
    ActionType.CreatePlanFromTaskAction,
    ActionType.CreatePlanFromTaskCompletedAction,
    ActionType.ResetCreatePlanFromTaskOperationAction,
    ActionType.MovePlanOperationAction,
    ActionType.MovePlanOperationCompletedAction,
    ActionType.MovePlanOperationCompletedWithErrorsAction,
    ActionType.ResetMovePlanOperationAction,
    ActionType.ExtendPlanExpiryOperationAction,
    ActionType.ExtendPlanExpiryOperationCompletedAction,
    ActionType.ExtendPlanExpiryOperationCompletedWithErrorsAction,
    ActionType.ResetExtendPlanExpiryOperationAction,
    ActionType.SetPlanFilterAction,
    ActionType.SetRecommendedPlansAction,
    ActionType.RemovePlanFromRecommendedListAction,
    ActionType.CreatePlanFromTemplateAction,
    ActionType.CreatePlanFromTemplateSucceededAction,
    ActionType.CreatePlanFromTemplateFailedAction,
    ActionType.CreatePlanFromTemplateResetAction,
    ActionType.SuspendEntityDeltaAction,
    ActionType.ResumeEntityDeltaAction,
    ActionType.DropSuspendedDeltaAction,
    ActionType.PruneBaselineChainAction
];
